import { render, staticRenderFns } from "./HistoricoAlteracoes.vue?vue&type=template&id=23702500&"
import script from "./HistoricoAlteracoes.vue?vue&type=script&lang=js&"
export * from "./HistoricoAlteracoes.vue?vue&type=script&lang=js&"
import style0 from "./HistoricoAlteracoes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports